import { Component } from 'react';

// ErrorBoundary is a class component and cannot use hooks (useTranslation),
// so we read the language from localStorage and use the i18n JSON directly.
const getErrorText = () => {
  try {
    const lang = localStorage.getItem('emh_language') || 'ja';
    if (lang === 'en') {
      return { title: '⚠️ An error occurred', reload: '🔄 Reload' };
    }
    return { title: '⚠️ エラーが発生しました', reload: '🔄 リロード' };
  } catch {
    return { title: '⚠️ エラーが発生しました', reload: '🔄 リロード' };
  }
};

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const texts = getErrorText();
      return (
        <div style={{ padding: 40, color: '#fff', background: '#1a1a2e', minHeight: '100vh', fontFamily: 'monospace' }}>
          <h1 style={{ color: '#e74c3c' }}>{texts.title}</h1>
          <pre style={{ color: '#f39c12', whiteSpace: 'pre-wrap', marginTop: 20 }}>
            {this.state.error && this.state.error.toString()}
          </pre>
          <pre style={{ color: '#95a5a6', whiteSpace: 'pre-wrap', marginTop: 10, fontSize: 12 }}>
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: 20, padding: '10px 20px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            {texts.reload}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
